(function () {
  let FORM_ID = 'verify-form';

  // Hostnames that are trusted to skip captcha/length validation when scanned.
  // Add both with and without "www." if needed.
  const TRUSTED_VERIFY_HOSTS = ['www.kent.co.in', 'kent.co.in'];
  const TRUSTED_VERIFY_PATH = '/verify';
  const TRUSTED_VERIFY_PARAM = 'sc';

  // window.verifyFormRecaptchaCallback = function () {
  //   let form = document.getElementById(FORM_ID);
  //   if (!form) return;
  //   let block = form.querySelector('[data-verify-field="captcha"]');
  //   let err = block ? block.querySelector('.text-error') : null;
  //   if (err) err.textContent = '';
  // };

  // Removes all whitespace (spaces, tabs, newlines) from a value.
  function stripSpaces(value) {
    return (value || '').replace(/\s+/g, '');
  }

  // Attempts to read a trusted "sc" code out of a scanned URL.
  // Returns the code string if valid, or null if the scanned text
  // doesn't match the expected verify-link shape.
  function extractTrustedScanCode(decodedText) {
    let text = (decodedText || '').trim();
    if (!text) return null;

    let parsed;
    try {
      parsed = new URL(text);
    } catch (e) {
      return null; // not a URL at all
    }

    let host = parsed.hostname.toLowerCase();
    if (TRUSTED_VERIFY_HOSTS.indexOf(host) === -1) return null;

    let path = parsed.pathname.replace(/\/+$/, '').toLowerCase();
    if (path !== TRUSTED_VERIFY_PATH) return null;

    let code = parsed.searchParams.get(TRUSTED_VERIFY_PARAM);
    if (!code || !stripSpaces(code)) return null;

    return stripSpaces(code);
  }

  // qr-scanner's decode callback/scanImage() can resolve either a plain
  // string or a { data, cornerPoints } object depending on options/version,
  // so normalize both shapes to a plain string here.
  function normalizeScanResult(result) {
    if (!result) return '';
    if (typeof result === 'string') return result;
    if (typeof result.data === 'string') return result.data;
    return '';
  }

  function run() {
    const scanBtn = document.getElementById('scan-qr-btn');
    const closeBtn = document.getElementById('close-qr-btn');
    const qrModal = document.getElementById('qr-scan-modal');
    const videoEl = document.getElementById('qr-reader');
    const scanStatus = document.getElementById('qr-scan-status');
    const torchBtn = document.getElementById('qr-torch-btn');
    const zoomInBtn = document.getElementById('qr-zoom-in-btn');
    const zoomOutBtn = document.getElementById('qr-zoom-out-btn');
    const captureBtn = document.getElementById('qr-capture-btn');
    let mediaStream = null;
    let scanLoopTimer = null;
    let isScanning = false;
    let torchOn = false;
    let zoomCaps = null; // { min, max, step } when the camera supports zoom
    let currentZoom = 1;
    let lastHandledText = null;
    let lastHandledAt = 0;
    const RESCAN_COOLDOWN_MS = 2500; // avoid re-processing the same frame result repeatedly

    if (typeof QrScanner === 'undefined') {
      if (scanStatus) scanStatus.textContent = 'QR scanner failed to load. Please enter the serial number manually.';
    }

    const STATUS_ICONS = {
      info: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.6"/><path d="M10 9V14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="10" cy="6.3" r="1" fill="currentColor"/></svg>',
      success: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.6"/><path d="M6.5 10.2L8.8 12.5L13.5 7.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      error: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.6"/><path d="M10 6V11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="10" cy="13.7" r="1" fill="currentColor"/></svg>'
    };

    function setScanStatus(message, type) {
      if (!scanStatus) return;
      scanStatus.classList.remove('status-info', 'status-success', 'status-error', 'is-visible');
      if (!message) {
        scanStatus.innerHTML = '';
        return;
      }
      let kind = type === true ? 'error' : (type || 'info'); // backwards-compatible with old boolean usage
      if (kind !== 'info' && kind !== 'success' && kind !== 'error') kind = 'info';
      scanStatus.classList.add('status-' + kind, 'is-visible');
      scanStatus.innerHTML = (STATUS_ICONS[kind] || '') + '<span>' + message + '</span>';
    }

    function openModal() {
      if (!qrModal) return;
      qrModal.classList.add('is-open');
      qrModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!qrModal) return;
      qrModal.classList.remove('is-open');
      qrModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function stopScanner() {
      isScanning = false;
      if (scanLoopTimer) {
        clearTimeout(scanLoopTimer);
        scanLoopTimer = null;
      }
      if (mediaStream) {
        mediaStream.getTracks().forEach(function (track) {
          try { track.stop(); } catch (e) { /* ignore */ }
        });
        mediaStream = null;
      }
      if (videoEl) {
        videoEl.srcObject = null;
      }
      closeModal();
      return Promise.resolve();
    }

    // Shared by the live camera scanner and the "capture & zoom" crop.
    // Runs the same trust-check + submit path regardless of where the
    // decoded text came from.
    function handleDecodedText(decodedText, opts) {
      opts = opts || {};

      if (!opts.skipCooldown) {
        let now = Date.now();
        // Ignore repeat reads of the exact same code within the cooldown
        // window (the camera will re-decode the same QR many times per
        // second while it's in frame).
        if (decodedText === lastHandledText && (now - lastHandledAt) < RESCAN_COOLDOWN_MS) {
          return;
        }
        lastHandledText = decodedText;
        lastHandledAt = Date.now();
      }

      let trustedCode = extractTrustedScanCode(decodedText);

      if (!trustedCode) {
        setScanStatus('Please scan a valid QR.', 'error');
        // Keep the camera running so the user can try another code.
        return;
      }

      // Valid scanned link: fill the field for visibility, then submit
      // straight to the API, bypassing captcha and length validation
      // since the scan itself is the trust signal.
      let input = document.getElementById('verify-order-number');
      if (input) {
        input.value = trustedCode;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }

      setScanStatus('QR verified. Checking...', 'success');
      stopScanner();
      submitVerification(trustedCode, { skipValidation: true });
    }

    function getActiveTrack() {
      if (!videoEl || !videoEl.srcObject || typeof videoEl.srcObject.getVideoTracks !== 'function') return null;
      let tracks = videoEl.srcObject.getVideoTracks();
      return (tracks && tracks[0]) || null;
    }

    function updateTorchAvailability() {
      let track = getActiveTrack();
      if (!torchBtn || !track || typeof track.getCapabilities !== 'function') {
        if (torchBtn) torchBtn.style.display = 'none';
        return;
      }
      try {
        let capabilities = track.getCapabilities();
        torchBtn.style.display = (capabilities && capabilities.torch) ? 'inline-flex' : 'none';
      } catch (e) {
        torchBtn.style.display = 'none';
      }
    }

    function toggleTorch() {
      let track = getActiveTrack();
      if (!track || typeof track.applyConstraints !== 'function') return;
      let nextTorchOn = !torchOn;
      track.applyConstraints({ advanced: [{ torch: nextTorchOn }] })
        .then(function () {
          torchOn = nextTorchOn;
          if (torchBtn) torchBtn.classList.toggle('is-active', torchOn);
        })
        .catch(function () {
          // Ignore; flash toggle failed (device/browser doesn't support it).
        });
    }

    function updateZoomAvailability() {
      let track = getActiveTrack();
      if (!track || typeof track.getCapabilities !== 'function') {
        zoomCaps = null;
        if (zoomInBtn) zoomInBtn.style.display = 'none';
        if (zoomOutBtn) zoomOutBtn.style.display = 'none';
        return;
      }
      try {
        let capabilities = track.getCapabilities();
        if (capabilities && capabilities.zoom && typeof capabilities.zoom === 'object') {
          zoomCaps = capabilities.zoom;
          let settings = (typeof track.getSettings === 'function') ? track.getSettings() : {};
          currentZoom = (settings && settings.zoom) || zoomCaps.min || 1;
          if (zoomInBtn) zoomInBtn.style.display = 'inline-flex';
          if (zoomOutBtn) zoomOutBtn.style.display = 'inline-flex';
        } else {
          zoomCaps = null;
          if (zoomInBtn) zoomInBtn.style.display = 'none';
          if (zoomOutBtn) zoomOutBtn.style.display = 'none';
        }
      } catch (e) {
        zoomCaps = null;
      }
    }

    function applyZoom(nextZoom) {
      let track = getActiveTrack();
      if (!track || !zoomCaps || typeof track.applyConstraints !== 'function') return;
      let clamped = Math.min(zoomCaps.max, Math.max(zoomCaps.min, nextZoom));
      track.applyConstraints({ advanced: [{ zoom: clamped }] })
        .then(function () {
          currentZoom = clamped;
        })
        .catch(function () {
          // Ignore; zoom adjustment failed, leave current zoom as-is.
        });
    }

    // Some Android/Chrome cameras default to a single-shot autofocus after
    // start(); forcing continuous mode helps a lot when people move the
    // phone closer to a small, hard-to-read printed code. iOS Safari does
    // not expose focus capabilities to web pages at all (a platform
    // restriction Apple enforces, not something fixable from JS), so this
    // is a no-op there — expected, not a bug.
    function enableContinuousFocusIfSupported(attemptsLeft) {
      attemptsLeft = (typeof attemptsLeft === 'number') ? attemptsLeft : 3;
      let track = getActiveTrack();
      if (!track || typeof track.getCapabilities !== 'function') return;
      try {
        let capabilities = track.getCapabilities();
        if (capabilities && capabilities.focusMode && capabilities.focusMode.indexOf('continuous') !== -1) {
          track.applyConstraints({ advanced: [{ focusMode: 'continuous' }] }).catch(function () {});
        } else if (attemptsLeft > 0) {
          // Capabilities can be empty for a brief moment right after the
          // stream starts on some devices; retry a few times.
          setTimeout(function () { enableContinuousFocusIfSupported(attemptsLeft - 1); }, 300);
        }
      } catch (e) {
        // Ignore; not all browsers expose focusMode capabilities.
      }
    }

    // Grabs the current camera frame, crops it to the on-screen guide
    // frame, and scales that crop up before decoding — this is what
    // actually helps with small, low-contrast etched QR codes: the live
    // scan loop only ever sees the full, un-zoomed frame, but this gives
    // the decoder a much larger, cropped version of just the code itself.
    // Decodes straight off the canvas — no DOM container needed.
    function captureAndDecode() {
      if (!mediaStream || !videoEl || !videoEl.videoWidth) {
        setScanStatus('Camera is still starting up, please wait a moment and try again.', 'error');
        return;
      }

      setScanStatus('Capturing and zooming in...', 'info');

      let vw = videoEl.videoWidth;
      let vh = videoEl.videoHeight;
      // Matches the visual guide frame, which sits at 12% inset on all sides.
      let cropRatio = 0.76;
      let cropW = Math.floor(vw * cropRatio);
      let cropH = Math.floor(vh * cropRatio);
      let cropX = Math.floor((vw - cropW) / 2);
      let cropY = Math.floor((vh - cropH) / 2);

      let ZOOM_FACTOR = 3;
      let outW = cropW * ZOOM_FACTOR;
      let outH = cropH * ZOOM_FACTOR;

      let canvas = document.createElement('canvas');
      canvas.width = outW;
      canvas.height = outH;
      let ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      if ('imageSmoothingQuality' in ctx) ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(videoEl, cropX, cropY, cropW, cropH, 0, 0, outW, outH);

      QrScanner.scanImage(canvas, { returnDetailedScanResult: true })
        .then(function (result) {
          handleDecodedText(normalizeScanResult(result), { skipCooldown: true });
        })
        .catch(function () {
          setScanStatus('No QR code found in that frame. Try moving slightly closer or farther, then capture again.', 'error');
        });
    }

    // Manually pumps video frames through QrScanner.scanImage on an interval
    // instead of using qr-scanner's built-in camera+scan loop. This is what
    // lets us control the getUserMedia constraints ourselves (resolution,
    // continuous focus) rather than accepting whatever qr-scanner's
    // internal camera acquisition negotiates.
    function scanLoopTick() {
      if (!isScanning) return;
      if (!videoEl.videoWidth) {
        scanLoopTimer = setTimeout(scanLoopTick, 150);
        return;
      }
      QrScanner.scanImage(videoEl, { returnDetailedScanResult: true })
        .then(function (result) {
          handleDecodedText(normalizeScanResult(result));
        })
        .catch(function () {
          // No QR code found in this frame — expected most of the time, ignore.
        })
        .finally(function () {
          if (isScanning) {
            scanLoopTimer = setTimeout(scanLoopTick, 100); // ~10 scans/sec
          }
        });
    }

    function startScanner() {
      if (typeof QrScanner === 'undefined') {
        setScanStatus('QR scanner library did not load. Please enter the serial number manually or refresh the page.', 'error');
        return;
      }
      if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') {
        setScanStatus('Camera access is not available in this browser. Please enter the serial number manually.', 'error');
        return;
      }
      if (isScanning) {
        return; // guard against double-clicks
      }

      setScanStatus('');
      lastHandledText = null;
      torchOn = false;
      zoomCaps = null;
      currentZoom = 1;
      if (torchBtn) {
        torchBtn.style.display = 'none';
        torchBtn.classList.remove('is-active');
      }
      if (zoomInBtn) zoomInBtn.style.display = 'none';
      if (zoomOutBtn) zoomOutBtn.style.display = 'none';
      openModal();

      // Requesting a higher resolution and continuous autofocus as part of
      // the *initial* stream request (rather than patching it in after the
      // fact) is what actually gives Android/Chrome cameras a real chance
      // to focus quickly and decode small codes. On iOS Safari, focusMode
      // is silently ignored — Apple doesn't expose focus control to web
      // pages at all, so this is a harmless no-op there, not a failure.
      let constraints = {
        audio: false,
        video: {
          facingMode: { ideal: 'environment' },
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          advanced: [{ focusMode: 'continuous' }]
        }
      };

      navigator.mediaDevices.getUserMedia(constraints)
        .then(function (stream) {
          mediaStream = stream;
          videoEl.srcObject = stream;
          return videoEl.play();
        })
        .then(function () {
          isScanning = true;
          updateTorchAvailability();
          updateZoomAvailability();
          enableContinuousFocusIfSupported();
          scanLoopTick();
        })
        .catch(function (err) {
          closeModal();
          isScanning = false;
          let message = String(err && (err.message || err) || '');
          if (/denied|permission/i.test(message) || (err && err.name === 'NotAllowedError')) {
            setScanStatus('Camera access was denied. Please allow camera access or enter the serial number manually.', 'error');
          } else if (/not found|no camera/i.test(message) || (err && err.name === 'NotFoundError')) {
            setScanStatus('No camera was found on this device. Please enter the serial number manually.', 'error');
          } else {
            setScanStatus('Unable to start the camera. Please enter the serial number manually.', 'error');
          }
        });
    }


    // Strip spaces from the serial number as the user types or pastes,
    // so the field never holds a value with embedded whitespace.
    let orderNumberInput = document.getElementById('verify-order-number');
    if (orderNumberInput) {
      orderNumberInput.addEventListener('input', function () {
        let raw = orderNumberInput.value;
        let cleaned = stripSpaces(raw);
        if (cleaned !== raw) {
          let cursorPos = orderNumberInput.selectionStart || cleaned.length;
          let removedBefore = raw.slice(0, cursorPos).length - stripSpaces(raw.slice(0, cursorPos)).length;
          orderNumberInput.value = cleaned;
          let newPos = Math.max(0, cursorPos - removedBefore);
          if (typeof orderNumberInput.setSelectionRange === 'function') {
            orderNumberInput.setSelectionRange(newPos, newPos);
          }
        }
      });
    }

    if (scanBtn) {
      scanBtn.addEventListener('click', function () {
        startScanner();
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        stopScanner();
      });
    }

    if (torchBtn) {
      torchBtn.addEventListener('click', function () {
        toggleTorch();
      });
    }

    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', function () {
        if (!zoomCaps) return;
        let step = zoomCaps.step || (zoomCaps.max - zoomCaps.min) / 10 || 0.5;
        applyZoom(currentZoom + step * 3);
      });
    }
    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', function () {
        if (!zoomCaps) return;
        let step = zoomCaps.step || (zoomCaps.max - zoomCaps.min) / 10 || 0.5;
        applyZoom(currentZoom - step * 3);
      });
    }

    if (captureBtn) {
      captureBtn.addEventListener('click', function () {
        captureAndDecode();
      });
    }

    // Clicking the dark overlay itself (not the reader or the close button)
    // also closes the popup and stops the camera.
    if (qrModal) {
      qrModal.addEventListener('click', function (e) {
        if (e.target === qrModal) {
          stopScanner();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && qrModal && qrModal.classList.contains('is-open')) {
        stopScanner();
      }
    });

    // Stop the camera if the user navigates away while it's running
    window.addEventListener('beforeunload', function () {
      if (mediaStream) {
        mediaStream.getTracks().forEach(function (track) {
          try { track.stop(); } catch (e) { /* ignore */ }
        });
      }
      document.body.style.overflow = '';
    });

    let form = document.getElementById(FORM_ID);
    if (!form) return;

    function getVerifySubmitUrl() {
      if (typeof window.getAPIUrl !== 'function') return '';
      let baseUrl = window.getAPIUrl('baseUrl');
      if (!baseUrl) return '';
      let partEndpoint = 'part';
      return baseUrl.charAt(baseUrl.length - 1) === '/' ? baseUrl + partEndpoint : baseUrl + '/' + partEndpoint;
    }

    function getVerifycodeRedirectUrl(status, message) {
      let path = '/pages/verifycode';
      let params = new URLSearchParams({ status: status });
      if (message) params.set('message', message);
      return window.location.origin + path + '?' + params.toString();
    }

    function showError(field, message) {
      let block = form.querySelector('[data-verify-field="' + field + '"]');
      let err = block ? block.querySelector('.text-error') : null;
      if (err) err.textContent = message || '';
    }

    function clearErrors() {
      form.querySelectorAll('.text-error').forEach(function (el) { el.textContent = ''; });
    }

    let MIN_ORDER_NUMBER_LENGTH = 15;
    let MAX_ORDER_NUMBER_LENGTH = 16;
    let MIN_LENGTH_MESSAGE = 'Please enter a valid 15-16 character spare serial number';
    let MAX_LENGTH_MESSAGE = 'Spare serial number must be at most 16 characters.';

    function validate() {
      clearErrors();
      let valid = true;
      let orderInput = document.getElementById('verify-order-number');
      let orderVal = orderInput ? stripSpaces(orderInput.value) : '';
      if (!orderVal) {
        showError('order_number', 'Spare serial number is required.');
        valid = false;
      } else if (orderVal.length < MIN_ORDER_NUMBER_LENGTH) {
        showError('order_number', MIN_LENGTH_MESSAGE);
        valid = false;
      } else if (orderVal.length > MAX_ORDER_NUMBER_LENGTH) {
        showError('order_number', MAX_LENGTH_MESSAGE);
        valid = false;
      }
      // let recaptchaResponse = form.querySelector('textarea[name="g-recaptcha-response"]');
      // let captchaVal = recaptchaResponse ? recaptchaResponse.value : '';
      // if (!captchaVal) {
      //   showError('captcha', 'Please complete the captcha.');
      //   valid = false;
      // }
      return valid;
    }

    function setLoading(loading) {
      let btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = loading;
        btn.classList.toggle('loading', loading);
      }
    }

    function runFieldValidation(e) {
      let target = e.target;
      if (!target || !target.matches('input, select, textarea')) return;
      let block = target.closest('.form-block');
      if (!block || !form.contains(block)) return;
      let errEl = block.querySelector('.text-error');
      if (!errEl) return;
      if (block.getAttribute('data-verify-field') === 'order_number' && target.id === 'verify-order-number') {
        let val = stripSpaces(target.value);
        if (!val) {
          errEl.textContent = 'Spare serial number is required.';
        } else if (val.length < MIN_ORDER_NUMBER_LENGTH) {
          errEl.textContent = MIN_LENGTH_MESSAGE;
        } else if (val.length > MAX_ORDER_NUMBER_LENGTH) {
          errEl.textContent = MAX_LENGTH_MESSAGE;
        } else {
          errEl.textContent = '';
        }
      }
    }

    // Core API call, shared by manual submit and scan-to-submit.
    // opts.skipValidation = true means: no captcha check, no length check,
    // just send the code straight through (used for trusted scanned links).
    function submitVerification(code, opts) {
      opts = opts || {};

      let baseUrl = getVerifySubmitUrl();
      if (!baseUrl) {
        showError('order_number', 'API is not configured.');
        return;
      }
      let urlParams = new URLSearchParams(window.location.search);
      let userID = urlParams.get('userID') || 'test';
      let system = urlParams.get('system') || 'web';
      let params = new URLSearchParams({
        system: system,
        userID: userID,
        code: code
      });
      let url = baseUrl + (baseUrl.indexOf('?') !== -1 ? '&' : '?') + params.toString();
      let apiKey = (typeof window.getAPIUrl === 'function' && window.getAPIUrl('key')) || '';
      setLoading(true);
      fetch(url, {
        method: 'GET',
        headers: {
          'x-api-key': apiKey
        }
      })
        .then(function (res) {
          
          return res.text().then(function (text) {
            let isSuccess = false;
            let errorMessage = text || 'Request failed';
            try {
              let data = JSON.parse(text);
              let result = data && data.result;
              let product = result && result.product;
              if (res.ok && result && product != null) {
                isSuccess = true;
              } else {
                isSuccess = false;
                errorMessage = (result && result.message) || (data && data.message) || (data && data.error) || text || 'Request failed';
              }
            } catch (e) {
              isSuccess = false;
              errorMessage = text || 'Request failed';
            }
            if (isSuccess) {
              clearErrors();
              setScanStatus('');
              form.reset();
                window.location.href = getVerifycodeRedirectUrl('success', 'Serial no verified');
              } else {
              if (opts.skipValidation) {
                setScanStatus('Please scan a valid QR.', 'error');
              }
              console.log(errorMessage);
              window.location.href = getVerifycodeRedirectUrl('error', errorMessage);
            }
          });
        })
        .catch(function (err) {
          console.log(err);
          window.location.href = getVerifycodeRedirectUrl('error', err.message || 'Something went wrong. Please try again.');
        })
        .finally(function () {
          setLoading(false);
        });
    }

    // form.addEventListener('submit', function (e) {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   if (!validate()) {
    //     let firstError = form.querySelector('.text-error');
    //     if (firstError && firstError.textContent.trim()) {
    //       firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    //     }
    //     return;
    //   }

    //   let orderInput = document.getElementById('verify-order-number');
    //   let code = orderInput ? stripSpaces(orderInput.value) : '';
    //   submitVerification(code, { skipValidation: false });
    // });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!validate()) {
        let firstError = form.querySelector('.text-error');
        if (firstError && firstError.textContent.trim()) {
          firstError.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
        return;
      }
      let orderInput = document.getElementById('verify-order-number');
      let code = orderInput ? stripSpaces(orderInput.value) : '';
      // Generate a Google reCAPTCHA v3 token
      window.KentRecaptcha.getToken('submit')
        .then(function (recaptchaToken) {
          if (!recaptchaToken) {
            throw new Error('reCAPTCHA verification failed.');
          }
          // Submit only after token generation succeeds
          submitVerification(code, {
            skipValidation: false,
            recaptchaToken: recaptchaToken
          });
        })
        .catch(function (err) {
          console.error('[Verify Form] reCAPTCHA error:', err);
          showError(
            'order_number',
            'Security verification failed. Please refresh and try again.'
          );
        });
    });

    form.addEventListener('input', runFieldValidation);
    form.addEventListener('change', runFieldValidation);
    form.addEventListener('blur', runFieldValidation, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }
  else {
    run();
  }
})();